module.exports = __webpack_public_path__ + "img/18_63.da99c1d1.png";